import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const BlogCard = ({ post }) => {
  const { slug, title, category, date, excerpt, author, image } = post;
  const primaryCategory = category?.split('|')[0]?.trim() || 'Article';
  const isBookCover = image && image.includes('SBT_COVER');

  return (
    <Link to={`/blog/${slug}`} data-testid={`blog-card-${slug}`} className="group block">
      <article className="h-full overflow-hidden card-cinematic">
        {image && (
          <div className={`overflow-hidden relative ${isBookCover ? 'aspect-[16/10] bg-[#FAF9F6] flex items-center justify-center' : 'aspect-[16/10]'}`}>
            {isBookCover ? (
              <img src={image} alt={title} className="h-[85%] w-auto object-contain transition-transform duration-700 group-hover:scale-105" style={{ filter: 'drop-shadow(0 10px 25px rgba(200, 164, 72, 0.3))' }} loading="lazy" />
            ) : (
              <>
                <img src={image} alt={title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" style={{ filter: 'saturate(0.8) contrast(1.05)' }} loading="lazy" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#080808]/60 via-transparent to-[#080808]/20 pointer-events-none" />
              </>
            )}
          </div>
        )}
        <div className="p-6">
          <span className="inline-flex items-center px-3 py-1 mb-4 text-[9px] tracking-[0.2em] uppercase border border-[rgba(201,168,76,0.3)] text-[#C25E3E]" style={{ fontFamily: "'DM Mono', monospace" }}>
            {primaryCategory}
          </span>
          <h3 className="text-xl font-semibold mb-3 line-clamp-2 group-hover:text-[#C25E3E] transition-colors duration-300" style={{ fontFamily: "'Cormorant Garamond', serif", color: '#F4F0E6' }}>{title}</h3>
          <p className="text-[10px] tracking-[0.1em] mb-3" style={{ fontFamily: "'DM Mono', monospace", color: 'rgba(250,248,244,0.2)' }}>
            {date} {author && `· ${author}`}
          </p>
          <p className="text-[15px] line-clamp-2 leading-[1.7]" style={{ fontFamily: "'Lora', serif", color: 'rgba(250,248,244,0.35)' }}>{excerpt}</p>
          <span className="inline-flex items-center gap-2 mt-5 text-[10px] tracking-[0.15em] uppercase opacity-0 group-hover:opacity-100 transition-all duration-300 translate-y-2 group-hover:translate-y-0" style={{ fontFamily: "'DM Mono', monospace", color: '#C25E3E' }}>
            Read Article <ArrowRight size={11} />
          </span>
        </div>
        <div className="h-[2px] bg-[#C25E3E] scale-x-0 group-hover:scale-x-100 transition-transform origin-left duration-500" />
      </article>
    </Link>
  );
};

export default BlogCard;
